import { gql } from '@apollo/client'

export default gql(`
    mutation createAccessRoleGroup($description: String $name: String! $users:[CreateUserInput] $modules:[ModulePermissionsInput] $project: String $ip: [String] $masterFlag: Boolean) {
        createAccessRoleGroup(
            input: {
                name: $name
                description: $description
                users: $users
                modules: $modules
                ip: $ip
                masterFlag: $masterFlag
            }
            project: $project
        ){
            id
            name
            description
            createdAt
            ip
            masterFlag
            modules{
                name
                permissions
            }
            users{
                id
                accessRoleGroups {
                    id
                }
            }
        }
    }
`)
